// extracted by mini-css-extract-plugin
export default {"showMore":"views-ContentPage-components-themes-BGH-editorials__showMore--lO4C0","margin":"views-ContentPage-components-themes-BGH-editorials__margin--zKlag"};